<template>
  <li>
    <div  v-if="index"
            :class="{bold: isFolder}"
            @click="toggle">

      <span v-if="isFolder"><i :class="[open ? 'fas fa-folder-open' : 'fas fa-folder']"></i> {{ index }} 1</span>
      <span v-if="!isFolder && !deleted"><i class="fas fa-file"></i><a :href="model['download']"> {{ index }} </a>
        <span><button aria-label="Delete" type="button" class="btn btn btn-link btn-small text-danger" v-on:click="deleteFile"><i class="fas fa-fw" :class="loading ? 'fa-spinner fa-pulse' : 'fas fa-trash-alt'"></i></button></span>
      </span>
    </div>
    <ul v-show="open" v-if="isFolder">
      <file
              class="file m-1"
              v-for="(model, index) in model"
              :key="index"
              :model="model"
              :index="index">
      </file>
    </ul>
  </li>
</template>

<script>
  export default {
    props: {
      model: {},
      index: false
    },
    data: function () {
      return {
        open: !this.index,
        deleted: false,
        loading: false
      }
    },
    computed: {
      isFolder: function () {
        let isFolder = typeof this.model !== 'string';
        if (this.model['download'] !== undefined) {
          isFolder = false;
        }
        return isFolder;
      }
    },
    methods: {
      toggle: function () {
        if (this.isFolder) {
          this.open = !this.open
        }
      },

      deleteFile: function() {
        let scope = this;
        let URL = scope.model['delete'];
        let config = {
          headers:{
            'X-HTTP-Method-Override':'DELETE'
          }
        };
        
        if (confirm("Are you sure you want to delete ?")) {
          scope.loading = true;
          axios.delete(URL, config)
            .then(e => {
              scope.loading = false;
              if (e.data) {
                scope.deleted = true;
              } else {
                scope.notification = {
                  type: 'error',
                  message: 'File couldn\'t be deleted'
                };
              }
            })
            .catch(e => {
              scope.notification = {
                type: 'error',
                message: 'File couldn\'t be deleted'
              };
              console.log("failed");
            })
        }
      },
    }
  }
</script>

<style scoped>
  .file {
    cursor: pointer;
  }
  ul {
    padding-left: 1em;
    line-height: 1.5em;
    list-style-type: none;
  }
  li  {
    list-style-type: none;
    font-size: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/file.vue